import { OnInit, Component } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { IJobsForDeleteFilter } from '../../interfaces/inbox-job-filter';
import { IPageResult } from '../../interfaces/page-result';
import { InboxJobsService } from '../../services';
import { OrderService } from '../../services';
import { UserService } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { ConfirmationService } from 'primeng';
import { IImportResult } from '../../interfaces/data-import/import-result';

@Component({
  selector: 'job-delete',
  styleUrls: ['./job-delete.component.css'],
  templateUrl: './job-delete.component.html',
  providers: [ConfirmationService],
})
export class JobDeleteComponent implements OnInit {
  public page: IPageResult<any> = {
    items: [],
    total: 0,
  };

  public filter: Subject<IJobsForDeleteFilter>;
  public filterVal: IJobsForDeleteFilter;

  public data: string;
  public organisationTypeId: number;
  public selectedJob: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private orderService: OrderService,
    private inboxjobsService: InboxJobsService,
    private confirmationService: ConfirmationService,
    public messageService: MessageService,
  ) {}

  ngOnInit() {
    this.initDefaultFilter();

    this.filter = new Subject<IJobsForDeleteFilter>();

    // subscribe to filter changes with a debounce time
    this.filter.pipe(debounceTime(500)).subscribe((f) => {
      this.load(f);
      this.filterVal = f;
    });

    // set default filter
    //this.filter.next(this.filterVal);
  }

  load(filter: IJobsForDeleteFilter) {
    this.orderService.getJobsForDeletePage(filter).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
    });
  }

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filter.next(this.filterVal);
  }

  initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: '', // ASC
      sortOrder: 1,
      filters: {
        jobNumber: { value: '' },
        jobNumberList: { value: [] },
      },
    };
  }

  search() {
    this.load(this.filterVal);
  }

  clearFilter() {
    this.initDefaultFilter();
    this.load(this.filterVal);
  }

  onFileUpload(event) {
    // var response = JSON.parse(event.xhr.response);
    const response = event.originalEvent.body;
    this.filterVal.filters.jobNumberList.value = response;
    this.load(this.filterVal);
  }

  deleteAll() {
    // this.filterVal.filters.jobNumberList.value
    this.confirmationService.confirm({
      message: `Are you sure want to completely delete ${this.page.total} jobs?`,
      accept: () => {
        this.orderService.deleteJobs(this.filterVal.filters.jobNumberList.value).then((res) => {
          this.load(this.filterVal);
        });
      },
    });
  }

  deleteSelected(item) {
    this.confirmationService.confirm({
      message: 'Are you sure want to completely delete selected job?',
      accept: () => {
        this.orderService.deleteJobs([item.jobNumber]).then((res) => {
          this.load(this.filterVal);
        });
      },
    });
  }

  //=============== AlexP code ===================
  onCleanseUpload(event) {
    //var response = JSON.parse(event.xhr.response);
    const response = event.originalEvent.body;

    console.log('cleanse response', response);

    if (response.warning) {
      this.messageService.add(Message.Error(response.warning, 'Error'));
    } else if (!response.validEntries.length) {
      this.messageService.add(Message.Error('No records processed', 'Error'));
    } else {
      this.messageService.add(
        Message.Success(
          `${response.validEntries.length} record(s) successfully processed`,
          'Success',
        ),
      );
    }
  }

  //=============== /AlexP code ===================
}
